<template>
	<!--  个人信息  -->
	<div class="container">
		<div class="user-card">
			<div class="g-p-20 g-flex">
				<!--  头像  -->
				<div class="g-text-center avatar-box">
					<img :src="userInfo.avatar" class="avatar" alt="" v-if="userInfo.avatar!=''">
					<img src="@/assets/mine/upload.png" class="avatar" alt="" v-else>
					<uploadBtn @uploadSuccess="uploadSuccess" @removeSuccess="removeSuccess"></uploadBtn>
				</div>
				<!--  信息  -->
				<div class="g-m-l-46 info-box">
					<div class="g-p-30">
						<div class="g-flex g-row-between">
							<div>
								<div class="g-flex">
									<p class="main-text g-font-16 g-nowrap g-m-r-10">姓名：</p>
									<el-input class="inputs" v-model="userInfo.realName"></el-input>
								</div>

								<div class="g-flex g-m-t-10">
									<p class="main-text g-font-16 g-m-r-10">性别：</p>
									<el-select class="inputs" v-model="userInfo.sex" placeholder="请选择">
										<el-option v-for="item in sex_list" :key="item.dictKey" :label="item.dictValue"
											:value="item.dictKey">
										</el-option>
									</el-select>
								</div>
								<div class="g-flex g-m-t-10">
									<p class="g-font-16 g-m-r-10">生日：</p>
									 <el-date-picker class="inputs"
									      v-model="userInfo.birthday"
									      type="date"
									      placeholder="选择生日" @change="changeBirthday" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
									    </el-date-picker>
								</div>
								<div class="g-flex g-m-t-10">
									<p class="g-font-16 g-m-r-10">年龄：</p>
									<el-input class="inputs" v-model="age" oninput="value=value.replace(/[^\d]/g,'')" disabled>
									</el-input>
								</div>

								<div class="g-flex g-m-t-10">
									<p class="g-font-16 g-m-r-10">电话：</p>
									<el-input class="inputs" v-model="userInfo.phone"
										oninput="value=value.replace(/[^\d]/g,'')" disabled></el-input>
								</div>
							</div>

							<div>
								<div class="g-flex">
									<p class="g-font-16 g-nowrap g-m-r-10">工作年限：</p>

									<el-select class="inputs" v-model="userInfo.workingSeniority" placeholder="请选择">
										<el-option v-for="item in work_year_list" :key="item.dictKey"
											:label="item.dictValue" :value="item.dictKey">
										</el-option>
									</el-select>
								</div>

								<div class="g-flex g-m-t-10">
									<p class=" g-font-16 g-m-r-40">学历：</p>
									<el-select class="inputs" v-model="userInfo.diploma" placeholder="请选择">
										<el-option v-for="item in diploma_list" :key="item.dictKey"
											:label="item.dictValue" :value="item.dictKey">
										</el-option>
									</el-select>
								</div>

								<div class="g-flex g-m-t-10">
									<p class=" g-font-16 g-m-r-40">邮箱：</p>
									<el-input class="inputs" v-model="userInfo.email"></el-input>
								</div>

								<div class="g-flex g-m-t-10">
									<p class=" g-font-16 g-m-r-25">微信号：</p>
									<el-input class="inputs" v-model="userInfo.wechat"></el-input>
								</div>
								<div class="g-flex g-m-t-10" style="height: 50px;">

								</div>
							</div>
						</div>
						<div class="save-btn g-m-t-20" @click="doSave">
							保存
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--  我的证书  -->
		<div class="g-m-t-30 white-bg">
			<div class="g-p-30">
				<el-tabs v-model="tabNow">
					<el-tab-pane label="我的证书" name="1"></el-tab-pane>
				</el-tabs>
				<div class="g-flex g-flex-wrap">
					<div class="certificate">
						<div class="g-p-10 g-m-r-12 g-m-t-12" style="box-shadow: 0 0 10px 0 rgba(64, 122, 255, 0.10);" v-for="item in certificateDataList">
              <el-image
                  class="cer-img"
                  :src="item.backImg"
                  :preview-src-list="[item.backImg]">
              </el-image>
							<div class="g-text-center g-m-t-15 g-font-16">
								{{ item.subjectName }}
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
		<!--  保存提示  -->
		<popup-message-box ref="popup" @submit="doSubmit">
			<p class="g-text-center g-font-20 g-m-t-10">已更新！</p>
		</popup-message-box>
	</div>
</template>

<script>
	import PopupMessageBox from "@/components/message-popup";
	import uploadBtn from "@/components/upload-btn";
	import {
		getCertificateMyList
	} from "@/api/user";
	import {
		updateUserInfo,
		userInfo
	} from "@/api/user.js"
	import {
		dictionary
	} from "@/api/api.js"

	export default {
		name: "user-info",
		components: {
			PopupMessageBox,
			uploadBtn
		},
		props: ['user'],
		data() {
			return {
				age: 0,
				userInfo: {},
				diploma_list: [], //学历
				salary_list: [], //薪资
				working_seniority_list: [], //年限
				work_year_list: [], //年限
				sex_list: [{
						dictKey: 1,
						dictValue: '男'
					},
					{
						dictKey: 2,
						dictValue: '女'
					},
					{
						dictKey: 3,
						dictValue: '未知'
					}
				], //性别
				tabNow: '1', //菜单下标
				year: '',
				work_year_map: {},
				certificateDataList: []
			}
		},
		computed: {},
		created() {
			this.getUserInfo()
			//this.userInfo=JSON.parse(JSON.stringify(this.user))

			this.getDictionary('diploma')
			//this.getDictionary('salary')
			// this.getDictionary('working_seniority')
			this.getDictionary('work_year')
			this.queryCertificateMyList()
		},
		methods: {
			changeBirthday(e){
				console.log(e)
				this.age = parseInt(this.year) - parseInt(e.split('-')[0]);
			},
			queryCertificateMyList() {
				getCertificateMyList().then(res => {
					this.certificateDataList = res
				})
			},
			getUserInfo() {
				userInfo({}).then(res => {
					console.log(res)
					this.userInfo = res
					this.year = new Date().getFullYear()
					if (this.userInfo.birthday === '') {
						this.age = ''
					} else {
						this.age = parseInt(this.year) - parseInt(this.userInfo.birthday.split('-')[0]);
					}
				})
			},
			uploadSuccess(e) {
				console.log(e)
				this.userInfo.avatar = e
			},
			removeSuccess(e) {
				this.userInfo.avatar = ''
			},
			getDictionary(type) {
				dictionary({
					code: type
				}).then(res => {
					this[type + '_list'] = res;
					// if(type=='work_year'){
					// 	res.forEach(ele=>{
					// 		this.work_year_map[ele.dictKey] = ele.dictValue;
					// 	});
					// }
				})
			},
			//保存
			doSave() {
				//  todo...
				if (!this.userInfo.realName) {
					this.$message.error('姓名不能为空')
					return false;
				}
				if (!this.userInfo.sex || userInfo.sex < 1) {
					this.$message.error('性别不能为空')
					return false;
				}
				if (!this.userInfo.phone) {
					this.$message.error('电话不能为空')
					return false;
				}
				if (!this.userInfo.workingSeniority) {
					this.$message.error('工作年限不能为空')
					return false;
				}
				//  else {
				// 	let temp = this.work_year_map[this.userInfo.workingSeniority];
				// 	this.userInfo.workingSeniorityName = !!temp?temp:this.userInfo.workingSeniority;
				// }
				if (!this.userInfo.diploma) {
					this.$message.error('学历不能为空')
					return false;
				}
				if (!this.userInfo.email) {
					this.$message.error('邮箱不能为空')
					return false;
				}
				if (!this.userInfo.wechat) {
					this.$message.error('微信不能为空')
					return false;
				}
				if (!this.age) {
					this.$message.error('年龄不能为空')
					return false;
				}
				if (this.age == '') {
					this.age = 0;
				}

				this.userInfo.birthday = this.userInfo.birthday.replaceAll(' ','').replaceAll('00:00:00','')+' '+'00:00:00'
				updateUserInfo(this.userInfo).then(res => {

					this.$emit('update', true)
					let storeUserInfo = this.$store.state.userInfo;
					Object.assign(storeUserInfo, this.userInfo);
					this.$store.commit('$uStore', {
						name: 'userInfo',
						value: storeUserInfo
					});
					// this.$store.commit('$uStore',{name:'userInfo.avatar',value:this.userInfo.avatar});
					this.$refs.popup.open()
				})
			},

			// 弹窗确认回调
			doSubmit() {
				this.$refs.popup.close()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.user-card {
		background: #fff;
		border-radius: 5px;

		.avatar-box {
			width: 195px;

			.avatar {
				width: 118px;
				height: 118px;
				border-radius: 50%;
				margin: 0 auto;
			}

			.btn {
				background: #f6f6f8;
				border-radius: 5px;
				color: #333;
				padding: 4px 17px;
				display: inline-block;

				&:hover {
					background: #407aff;
					color: #fff;
				}
			}

			.remark-text {
				text-align: justify;
			}
		}

		.info-box {
			background: #f6f6f8;
			border-radius: 5px;
			width: 654px;
		}

		.inputs {
			width: 180px;
		}
	}

	.white-bg {
		background: #ffffff;
		border-radius: 5px;
	}

	::v-deep .el-tabs__item.is-active {
		color: #333;
		font-size: 20px;
		font-weight: 500;
	}

	.certificate {
		background: #ffffff;
		border-radius: 5px;
    display: flex;
    flex-wrap: wrap;
    .cer-img {
			width: 188px;
			height: 269px;
		}
	}

	.save-btn {
		background: #eea906;
		border-radius: 5px;
		color: #fff;
		padding: 4px 26px;
		display: inline-block;
	}
</style>
